import { FC } from "react";
import { ProgressLoader } from "./progress-loader";

type LoaderProps = {
  show: boolean;
  fullscreen?: boolean;
  className?: string;
};

const Loader: FC<LoaderProps> = ({
  show,
  fullscreen = false,
  className = ""
}: LoaderProps) => {
  return (
    <ProgressLoader
      className={className ?? ""}
      show={show}
      fullscreen={fullscreen}
    />
  );
};

export default Loader;
